<template>
  <div>
    <form class="form">
      <div class="fieldSet">
        <h3 v-if="bubbleTitle">{{bubbleTitle}}</h3>
        <div class="field">
          <h1>Google - Login</h1>
          <a v-if="linkedAccounts.gmail"  href="#" class="bt btG" @click.prevent="disconnectGoogle"><i class="fab fa-google"/> - {{$t('profile.disconnect')}}</a>
          <a v-else  :href="googleSignUrl" class="bt btG"><i class="fab fa-google"/> - {{$t('profile.connect')}} </a>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import {RemoveUserLinkedAccountsLinkedAccountEnum, type UserLinkedAccountsOutput} from "~/api/generated";
import api from "~/api";

const config = useJsonConfig()
const linkedAccounts = ref<UserLinkedAccountsOutput>({
  mercadoPago: false,
  gmail: false,
})
const googleSignUrl = `${config.API_URL}login/redirect/google`
defineProps({
  bubbleTitle: String,
})

onMounted(async()=>{
  await refreshAccountsState()
})

async function disconnectGoogle () {
  await api.User.removeUserLinkedAccounts(RemoveUserLinkedAccountsLinkedAccountEnum.Google)
  await refreshAccountsState()
}

async function refreshAccountsState () {
  const apiResponse = await api.User.getUserLinkedAccounts()
  linkedAccounts.value = apiResponse.data
}
</script>
